import React from "react";
import { CardHeader, Tooltip } from "@material-tailwind/react";
import styles from "./SeedItem.module.css";
import { FaPodcast } from "react-icons/fa6";
import Avatar from "../../design-system/Avatar";
import { useNavigate } from "react-router-dom";
import { formatCustomTimestamp, getInitials } from "../../utils/common";
import { SeedItemProps } from "./SeedItem";
import { BASE_FRONT_END_URL } from "../../utils/appConstant";

function ShowPodcastItemInSeedSearch({ seed, onCitationClick }: Readonly<SeedItemProps> & {onCitationClick:any} ) {
    const navigate = useNavigate();
    function decodeUnicode(input: string): string {
        return input.replace(/\\u[\dA-Fa-f]{4}/g, match => String.fromCharCode(parseInt(match.replace("\\u", ""), 16)));
    }

    function onCitationClicked(seed: any): void {
        if (onCitationClick) {
          onCitationClick(seed);
        }
      }
    // const podcastClicked = () => {
    //     const podcastCitation = seed?.citation?.replace(/\.txt$/, "");
    //     navigate(`/podcast/summary/${podcastCitation}`);
    // };

    return (
        <div onClick={e => {
            e.preventDefault();
            onCitationClicked(seed);
          }}
        className="my-2 cursor-pointer hover:cursor-pointer ">
       
                <CardHeader className="relative">
                    <div className={`${styles.header} p-1 text-gray-700`}>
                        <div className="flex items-center">
                            <Tooltip
                                content="Software People Stories"
                                className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50"
                                placement="right"
                            >
                                <div>
                                    <Avatar initials={getInitials("Software People Stories")} className="mr-2" />
                                </div>
                            </Tooltip>
                        </div>
                        <span className={`justify-self-center truncate w-full max-w-full text-gray-500`}>{formatCustomTimestamp(seed.date)}</span>
                        <h2 className={`justify-self-center font-title truncate w-full max-w-full`} title={seed.title}>
                            {seed.title}
                        </h2>
                        <div className="flex gap-4">
                            <Tooltip
                                content="Software People Stories Podcast Summary"
                                className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50"
                                placement="top"
                            >
                                <div>
                                    <FaPodcast className="inline" />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </CardHeader>
                {/* <CardBody className="p-2 h-96 overflow-hidden">
                {seed && seed.podcast_summary && (
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                        {decodeUnicode(seed.podcast_summary.replace(/\\n/g, "\n"))}
                    </ReactMarkdown>
                )}
            </CardBody> */}
        </div>
    );
}

export default ShowPodcastItemInSeedSearch;
